// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
body {
  margin: 0;
  font-family: Verdana, Geneva, sans-serif;
  background-color: #f9f9f9;
}

h1 {
  color: #333;
  text-align: center;
  padding-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,SAAS;EACT,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/* App.css */\nbody {\n  margin: 0;\n  font-family: Verdana, Geneva, sans-serif;\n  background-color: #f9f9f9;\n}\n\nh1 {\n  color: #333;\n  text-align: center;\n  padding-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
